export async function fetchCollection(id) {
  const response = await fetch(`/learning_pathway_collections/${id}.json`);

  if (!response.ok) {
    throw new Error(`Failed to load learning pathway collection ${id}`);
  }

  return response.json();
}
